import questionTemplate from './question.html';

function questionDirective() {
    'ngInject';

    /*
     * NOTE:
     * We are using "template: questionTemplate.template" instead of "templateUrl: questionTemplate.id"
     * because of a very strange issue with the first approach for this specific directive
     */
    return {
        replace: true,
        transclude: true,
        restrict: 'A',
        bindToController: {
            question: '=bbQuestion',
            adminRequired: '=bbAdminRequired',
            dateFormatLocale: '=bbDateFormat',
            defaultPlaceholder: '='
        },
        template: questionTemplate.template,
        controller: 'BBQuestionController',
        controllerAs: '$bbQuestionCtrl'
    };
}

angular
    .module('BB.inputs')
    .directive('bbQuestion', questionDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/question/question.directive.js